import Olmoforms from "@olmokit/core/olmoforms/feedback";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import FormUploadFile from "@olmokit/core/forms/file/olmominimal";
import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/textarea/filled";
import "./index.scss";

/**
 * Component: FormCareers
 *
 */
export function FormCareers() {

  const olmoform = Olmoforms(".FormCareer:", {
    sent: (response) => {
      const { formData } = response;
      const { attachment, ...cleanedFormData } = formData;
      dataLayer.push({
        ...cleanedFormData,
        event: "form sent",
        form: "Career Form",
      });
    },
  });

  FormsInputMaterial();
  FormsSelectMaterial();
  FormUploadFile();

  return {
    destroy() {
      olmoform.destroy();
    },
  };

}
